import styled, { CreateStyled } from '@emotion/styled'
import { Theme } from './theme'

export default styled as CreateStyled<Theme>
